import React from 'react';
import { Helmet } from 'react-helmet-async';

function BusinessVerification() {
	return (
		<section className="section">
			<div className="container">
				<Helmet>
					<title>Business Verification • APEX SPECIALTY CONTRACTING LLC</title>
					<meta name="description" content="Verification details for APEX SPECIALTY CONTRACTING LLC: legal name, address, services, and SMS usage policy." />
				</Helmet>
				<h2>Business Verification</h2>
				<div className="card" style={{ padding: 18 }}>
					<p><strong>Legal Name:</strong> APEX SPECIALTY CONTRACTING LLC</p>
					<p><strong>Address:</strong> 183 Highland Rd, Tarpon Springs, FL 34689, USA</p>
					<p><strong>Industry:</strong> Construction / Specialty Contracting</p>
					<p className="helper">
						<strong>Nature of Services:</strong> Professional specialty contracting services, including construction,
						renovation, and related project work for residential and commercial clients. We do not offer loans or make credit decisions.
					</p>
					<p className="helper">
						<strong>Legitimacy Statement:</strong> APEX SPECIALTY CONTRACTING LLC is a legitimate business operating in the United States.
						This website is operated solely to communicate with customers regarding projects, service updates, and scheduling.
					</p>
					<p className="helper">
						<strong>SMS Usage:</strong> SMS is used only for service-related communications (e.g., appointment confirmations, scheduling,
						project updates) and other messages as consented to by the user. Message frequency varies. Message and data rates may apply.
						Reply STOP to unsubscribe. Reply HELP for help.
					</p>
					<p className="helper">
						Contact: <a href="mailto:info@appexconnecthub.com">info@appexconnecthub.com</a> • Support: <a href="mailto:support@appexconnecthub.com">support@appexconnecthub.com</a>
					</p>
				</div>
			</div>
		</section>
	);
}

export default BusinessVerification;


